import { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import Select from "react-select";
import { allRoles } from "../../assets/constants";
import { database, storage } from "../../firebase";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
import { FormControl } from "react-bootstrap";
import Message from "../../components/Message";
import {toastGenerator} from './addCreditzSteps';

const AddContributers = ({
  fields,
  fields2,
  creditz,
  creditz2,
  handleRemove,
  handleRemove2,
  handleAdd,
  handleAdd2,
  setCredit,
  setCredit2,
  contributerFieldsErr
}) => {
  const user_roles = allRoles.map((role) => {
    return { value: role, label: role };
  });
  const [userEmailsObj, setUserEmailsObj] = useState([]);
  const [users, setUser] = useState([]);
  const [show, setShow] = useState(false);
  const [inviteErr, setInviteErr] = useState('')



  //////invite validation function ///////////
  function inviteValidate(){
    let check = true;
    if(creditz2.length!==0){
    for (const contributer of creditz2) {
    
    

      if(contributer.email===''?true:contributer.role===''?true:false){
        check= false;
        setInviteErr('Please fill all fields to proceed')
        toastGenerator('Please fill all fields to proceed');
        break;

      }
      else{
        check= true;
        setInviteErr('')
      }

      
    }
    setInviteErr('')
    return check;

  }
    console.log(check);
    return check?true:false;
  }


  const handleClose = () => {
    if (inviteValidate()) setShow(false);
    
  };
  const handleShow = () => setShow(true);

  

  
  function getUsers() {
    return database
      .ref(`/users`)
      .once("value")
      .then(async (snapshot) => {
        const array = [];
        snapshot.forEach((childSnapshot) => {
          array.push(childSnapshot.val());
        });
        setUser(array);
        const emailsObj = [];
        array.forEach(({ email, uid, accountType, username }) => {
          if (username && uid && accountType) {
            emailsObj.push({ label: username, value: uid, accountType, email });
          }
        });
        setUserEmailsObj(emailsObj);
      });
  }
  const styles = {
    container: (base) => ({
      ...base,
      flex: 1,
    }),
  };

  function handleChnage(e, idx) {
    let currentCredit = creditz[idx];
    currentCredit = {
      ...currentCredit,
      role: e.value,
      selectedRole: {
        label: e.value,
        value: e.value,
      },
    };
    const newCreitz = creditz.map((cedit, i) => {
      if (idx === i) {
        return currentCredit;
      }
      return cedit;
    });
    setCredit(newCreitz);
  }

  function handleChangeEmail(e, idx) {
    let currentCredit = creditz[idx];
    currentCredit = {
      ...currentCredit,
      email: e.email,
      uid: e.value,
      username: e.label,
      selectedUsername: {
        value: e.label,
        label: e.label,
      },
    };
    const newCreitz = creditz.map((cedit, i) => {
      if (idx === i) {
        return currentCredit;
      }
      return cedit;
    });
    setCredit(newCreitz);
  }
  useEffect(() => {
    getUsers();
  }, []);
  return (
    <>
      {creditz.length <= 0 ? (
        <p>Loading</p>
      ) : (
        <div
          className="card border-0 rounded-xl shadow-xs bg-primary"
          id="grad"
        >
          <div
            style={{
              textAlign: "center",
              marginTop: "10px",
              paddingTop: "5px",
            }}
          >
            <h5 className="fs-20 fw-bold mb-0" style={{ color: "white" }}>
              Add Contributers
            </h5>
          </div>
          
          <br></br>
          {fields.map((field, idx, label) => {
            return (
              <Row key={`${field}-${idx},${label}`}>
                <Col md="1"></Col>
                <Col md="4">
                  <Select
                    classNamePrefix="select with email"
                    options={user_roles}
                    onChange={(e) => {
                      handleChnage(e, idx);
                    }}
                    value={creditz[idx].selectedRole}
                  />
                  <br></br>
                </Col>

                <Col md="6">
                  <Select
                    styles={styles}
                    classNamePrefix="select with email"
                    name="email"
                    width="300px"
                    options={userEmailsObj}
                    onChange={(e) => {
                      handleChangeEmail(e, idx);
                    }}
                    value={creditz[idx].selectedUsername}
                  />
                </Col>

                <Col md="1">
                  {fields.length >= 1 ? (
                    <button
                      onClick={() => handleRemove(idx)}
                      className="mmwh-38 btn btn-secondary p-0 rounded-pill"
                      style={{ color: "white", marginTop: "4px" }}
                    >
                      <svg className="icon icon-4x">
                        <use href="#icon_cross"></use>
                      </svg>
                    </button>
                  ) : (
                    ""
                  )}
                </Col>
              </Row>
            );
          })}
          <br></br>
          <Row>
            <Col md="4"></Col>
            <Col md="3" sm="12" style={{padding:'0px'}}>
              {" "}
              <button
                className="btn btn-secondary "
                style={{ backgroundColor: "white", color: "purple"}}
                onClick={() => {
                  handleAdd();
                }}
              >
                <svg className="icon icon-5x me-2">
                  <use href="#icon_plus"></use>
                </svg>{" "}
                Add
              </button>
            </Col>
            <Col md="3" sm="12">
              <button
                className="btn btn-secondary "
                style={{ backgroundColor: "white" ,color: "purple"}}
                onClick={() => {
                  handleShow();
                }}
              >
                <svg className="icon icon-5x me-2">
                  <use href="#icon_plus"></use>
                </svg>{" "}
                Invite
              </button>
            </Col>
          </Row>
          <Row>
            <Col md="3"></Col>
            <Col md="3"><div style={{ color: "white", margin: "10px", textAlign: "center" }}>
                add contributers
              </div></Col>
            <Col md="5">
              <div style={{ color: "white", margin: "10px" }}>
                if you can't find who you're looking for
              </div>
            </Col>
          </Row>
          <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header>
              <Modal.Title>Invite Members</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div style={{ textAlign: "center", marginTop: "5px", letterSpacing: "2px" }}>
          
              </div>
              <div className="row">
                {fields2.map((field, idx, label) => {
                  return (
                    <div key={`${field}-${idx},${label}`}>
                      <div style={{ display: "flex" }}>
                        <div className="row">
                          <div className="col-md-12 mb-1">
                            <label
                              htmlFor="inputmanagement"
                              className="form-label fw-semibold fs-13 text-muted"
                            >
                              Role
                            </label>
                          </div>
                          <div className="row">
                            <div className="col-md-5 mb-1">
                              <Select
                                classNamePrefix="select with email"
                                options={user_roles}
                                
                                onChange={(e) => {
                                  let currentCredit = creditz2[idx];
                                  currentCredit = {
                                    ...currentCredit,
                                    role: e.value,
                                    selectedRole: {
                                      label: e.value,
                                      value: e.value,
                                    },
                                  };
                                  const newCreitz = creditz2.map((cedit, i) => {
                                    if (idx === i) {
                                      return currentCredit;
                                    }
                                    return cedit;
                                  });
                                  setCredit2(newCreitz);
                                }}
                                value={creditz2[idx].selectedRole}
                              />
                            </div>
                            <div
                              className="col-md-6 mb-1"
                              style={{ "padding-left": "50px",height:'50px' }}
                            >
                             
                                <FormControl
                                style={{height:'50px' }}
                                  placeholder="Email"
                                  aria-label="Email"
                                  aria-describedby="basic-addon1"
                                  value={creditz2[idx].email}
                                  onChange={(e) => {
                                    let currentCredit = creditz2[idx];
                                    currentCredit = {
                                      ...currentCredit,
                                      email: e.target.value,
                                    };
                                    const newCreitz = creditz2.map(
                                      (cedit, i) => {
                                        if (idx === i) {
                                          return currentCredit;
                                        }
                                        return cedit;
                                      }
                                    );
                                    setCredit2(newCreitz);
                                  }}
                                />
                            
                            </div>

                            <div className="col-md-1 mb-1">
                              {fields2.length >= 1 ? (
                                <button
                                  onClick={() => handleRemove2(idx)}
                                  className="mmwh-38 btn btn-secondary p-0 rounded-pill"
                                  style={{ paddingTop: "3.3%" }}
                                >
                                  <svg className="icon icon-4x">
                                    <use href="#icon_cross"></use>
                                  </svg>
                                </button>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button
                className="btn btn-secondary  px-3 px-sm-4 fw-semibold me-3"
                onClick={() => {
                  handleAdd2();
                }}
              >
                <svg className="icon icon-5x me-2">
                  <use href="#icon_plus"></use>
                </svg>{" "}
                Add
              </button>

              <Button variant="primary" onClick={handleClose}>
                Save Changes
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      )}
    </>
  );
};

export default AddContributers;
